<div class="onboarding-wrapper">
    <div class="position-relative">
        <div class="dark-theme fixed-top border-bottom">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg">
                        <div class="subtitle text-uppercase py-3">Getting Started with <i
                                class="font-weight-bold">Journey</i></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 0">
        <img class="w-100 img-fluid onboarding-countdown"
            src="https://equityisdynamic-static.s3.amazonaws.com/onboard/Countdown.gif">
        <div class="container-fluid container-lg">
            <div class="row py-5 mt-lg-5">
                <div class="col-12 col-lg-6">
                    <h2>Preparing for Takeoff</h2>
                    <div class="text-xlarge pt-4">Before getting started with Journey, let’s take a few minutes to
                        set up
                        your profile and review some key features that you might use.</div>
                </div>
            </div>
            <div class="row align-items-center py-4 py-lg-5">
                <div class="col-6 col-md col-lg text-gray"></div>
                <div class="col-6 col-md-auto col-lg-auto justify-content-end">
                    <button type="button" class="btn btn-primary px-lg-5 text-blue" href="#"
                        (click)="moveToNextStep()">continue</button>
                </div>
            </div>
        </div>
    </div>

    <div class="onboarding" *ngIf="currentIndex == 1">
        <div class="container-fluid container-lg">
            <div class="row py-5">
                <div class="col-12">
                    <h2>Tell us about you</h2>
                </div>
                <div class="col-12 col-lg-3 text-center text-md-left pt-4 pt-lg-5">
                    <image-upload #imageUpload></image-upload>
                </div>
            </div>
        </div>
        <div class="reflection-journal-theme border-bottom">
            <form [formGroup]="profileFormStep1">
                <div class="border-top">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <div class="py-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-10 subtitle">First Name*</div>
                                    </div>
                                    <div class="row pt-2">
                                        <div class="col-12 col-lg-9">
                                            <input type="text" formControlName="firstName"
                                                class="form-control text-xlarge" required>
                                            <ng-container *ngFor="let validation of validationMessages.firstName">
                                                <div class="error-message is-invalid text-red"
                                                    *ngIf="hasError(validation, 'firstName')">{{validation.message}}
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-6 border-top border-lg-top-0 border-lg-left">
                                <div class="py-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-10 subtitle">Last Name*</div>
                                    </div>
                                    <div class="row pt-2">
                                        <div class="col-12 col-lg-9">
                                            <input type="text" formControlName="lastName"
                                                class="form-control text-xlarge" required>
                                            <ng-container *ngFor="let validation of validationMessages.lastName">
                                                <div class="error-message is-invalid text-red"
                                                    *ngIf="hasError(validation, 'lastName')">{{validation.message}}
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-top">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">Email Address*</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 col-lg-9">
                                <input type="text" formControlName="emailAddress" readonly
                                    class="form-control text-xlarge" placeholder="me@mail.com" required>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-top border-bottom">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">About You</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 col-lg-9">
                                <input type="text" formControlName="aboutYou" class="form-control text-xlarge"
                                    placeholder="Share something about you.">
                                <ng-container *ngFor="let validation of validationMessages.aboutYou">
                                    <div class="error-message is-invalid text-red" *ngIf="hasError(validation, 'aboutYou')">
                                        {{validation.message}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="container-fluid">
            <div class="row py-5">
                <div class="col-12 text-center text-md-right">
                    <button type="button" class="btn btn-primary px-5  text-blue" href="#"
                        (click)="onSubmitProfileFormStep1()">continue</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 2">
        <div class="container-fluid container-lg">
            <div class="row py-5">
                <div class="col-12">
                    <h2>Tell us about your company</h2>
                </div>
                <div class="offset-3 col-6 offset-lg-0 col-lg-6 text-center text-md-left pt-4 pt-lg-5">
                    <img class="img-fluid w-100"
                        src="https://equityisdynamic-static.s3.amazonaws.com/onboard/Frame+(1).png">
                </div>
            </div>
        </div>
        <div class="reflection-journal-theme border-bottom">
            <form [formGroup]="profileFormStep2">
                <div class="border-top">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">Company Name*</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 col-lg-9">
                                <input type="text" formControlName="company" class="form-control text-xlarge"
                                    placeholder="Your Company Name" required>
                                <ng-container *ngFor="let validation of validationMessages.company">
                                    <div class="error-message is-invalid text-red" *ngIf="hasError(validation, 'company')">
                                        {{validation.message}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-top">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">Your Role at Company</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 col-lg-9">
                                <input type="text" formControlName="companyRol" class="form-control text-xlarge"
                                    placeholder="Your Role">
                                <ng-container *ngFor="let validation of validationMessages.companyRol">
                                    <div class="error-message is-invalid text-red" *ngIf="hasError(validation, 'companyRol')">
                                        {{validation.message}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-top">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">Company Location*</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 px-5">
                                <div class="border row">
                                    <div class="col-12 col-lg-4">
                                        <div class="py-3">
                                            <div class="row">
                                                <div class="col-12 subtitle pb-3" for="country">Country</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <ng-select [items]="countries" bindLabel="name" bindValue="id"
                                                        placeholder="Select country" [multiple]="false"
                                                        notFoundText="No countries found"
                                                        (change)="countryValueChanged($event)"
                                                        formControlName="country">
                                                    </ng-select>
                                                    <ng-container *ngFor="let validation of validationMessages.country">
                                                        <div class="error-message is-invalid text-red"
                                                            *ngIf="hasError(validation, 'country')">
                                                            {{validation.message}}</div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4" *ngIf="states.length > 0">
                                        <div class="py-3">
                                            <div class="row">
                                                <div class="col-12 subtitle pb-3" for="state">State</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <ng-select [items]="states" bindLabel="name" bindValue="id"
                                                        placeholder="Select state" [multiple]="false"
                                                        notFoundText="No states found"
                                                        (change)="stateValueChanged($event)" formControlName="state">
                                                    </ng-select>
                                                    <ng-container *ngFor="let validation of validationMessages.state">
                                                        <div class="error-message is-invalid text-red"
                                                            *ngIf="hasError(validation, 'state')">{{validation.message}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-4 ">
                                        <div class="py-3">
                                            <div class="row">
                                                <div class="col-12 subtitle pb-3" for="city">City</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <ng-select [items]="cities" bindLabel="name" bindValue="id"
                                                        placeholder="Select city" [multiple]="false"
                                                        notFoundText="No cities found" formControlName="city">
                                                    </ng-select>
                                                    <ng-container *ngFor="let validation of validationMessages.city">
                                                        <div class="error-message is-invalid text-red"
                                                            *ngIf="hasError(validation, 'city')">{{validation.message}}
                                                        </div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-top">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">Sector*</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 col-lg-9" *ngIf="sectors.length > 0">
                                <ng-select [items]="sectors" bindLabel="name" bindValue="id" placeholder="Select sector"
                                    [multiple]="true" notFoundText="No sectors found" formControlName="sectors">
                                </ng-select>
                                <ng-container *ngFor="let validation of validationMessages.sectors">
                                    <div class="error-message is-invalid text-red" *ngIf="hasError(validation, 'sectors')">
                                        {{validation.message}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-top">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">Company Website</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 col-lg-9">
                                <input type="text" autocapitalize="off" autocorrect="off"
                                    formControlName="companyWebsite" class="form-control text-xlarge"
                                    placeholder="www.company.com">
                                <ng-container *ngFor="let validation of validationMessages.companyWebsite">
                                    <div class="error-message is-invalid text-red"
                                        *ngIf="hasError(validation, 'companyWebsite')">{{validation.message}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border-top">
                    <div class="container-fluid py-4">
                        <div class="row">
                            <div class="col-12 col-lg-10 subtitle">About My Company</div>
                        </div>
                        <div class="row pt-2">
                            <div class="col-12 col-lg-9">
                                <input type="text" formControlName="aboutYourCompany" class="form-control text-xlarge"
                                    placeholder="Share something your company.">
                                <ng-container *ngFor="let validation of validationMessages.aboutYourCompany">
                                    <div class="error-message is-invalid text-red"
                                        *ngIf="hasError(validation, 'aboutYourCompany')">{{validation.message}}</div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="container-fluid">
            <div class="row py-5">
                <div class="col-12 text-center text-md-right">
                    <button type="button" class="btn btn-primary px-5  text-blue" href="#"
                        (click)="onSubmitProfileFormStep2()">continue</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 3">
        <div class="container-fluid container-lg">
            <div class="row py-5 align-items-center">
                <div class="col-12">
                    <h2>Stay up to date on new features</h2>
                </div>
                <div class="offset-3 col-6 offset-lg-0 col-lg-6 text-center text-md-left pt-4 pt-lg-5 px-lg-5">
                    <img class="img-fluid w-100" src="https://equityisdynamic-static.s3.amazonaws.com/onboard/Frame.png">
                </div>
                <div class="col-12 offset-lg-0 col-lg-6 py-5 py-lg-0">
                    <div class=" text-xlarge">Stay in touch through our email newsletter to get updates on new learning
                        activities, features, and improvements we are adding to Journey.
                    </div>
                    <div class="pt-4">
                        <input type="checkbox" id="radio" class="radio">
                        <label for="radio" class="text-large pl-3">Yes, I would like to get email updates</label>
                    </div>
                </div>
                <div class="col-12 text-center text-md-right pt-5 mt-lg-5">
                    <button type="button" class="btn btn-active px-5" href="#" (click)="onSubmitGetUpdatesForm()">Save
                        and Continue</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 4">
        <div class="container-fluid container-lg">
            <div class="row py-5">
                <div class="col-12 col-lg-6">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <div class="">
                            <div class="subtitle text-uppercase">FEATURES</div>
                            <h2 class="py-1">My Journey</h2>
                            <div class="text-xlarge pt-5">The <b>My Journey</b> section will show you where you are,
                                your status, and what Activities to do next. </div>
                        </div>
                        <div class="d-none d-lg-block text-center text-lg-right pt-4">
                            <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                                (click)="moveToNextStep()">continue</button>
                        </div>
                    </div>

                </div>
                <div
                    class="offset-1 col-10 offset-md-2 col-md-8 offset-lg-2 col-lg-4 text-center text-lg-right pt-5 pt-lg-4">
                    <img class="img-fluid w-100"
                        src="https://equityisdynamic-static.s3.amazonaws.com/onboard/journey.png">
                </div>
                <div class="col-12 d-lg-none text-center text-md-right pt-5 mt-md-5">
                    <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                        (click)="moveToNextStep()">continue</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 5">
        <div class="container-fluid container-lg">
            <div class="row py-5">
                <div class="col-12 col-lg-6">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <div class="mb-lg-5">
                            <div class="subtitle text-uppercase">FEATURES</div>
                            <h2 class="py-1">Activities</h2>
                            <div class="text-xlarge pt-5"><b>Activities</b> are where the learning happens. Each
                                Activity has learning material, reflection questions, and other interactive features
                                like worksheets and self-assessments to guide your Journey.</div>
                        </div>
                        <div class="d-none d-lg-block text-center text-lg-right pt-4 pt-lg-5 mt-lg-5">
                            <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                                (click)="moveToNextStep()">continue</button>
                        </div>
                    </div>

                </div>
                <div class="col-12 offset-md-1 col-md-10 offset-lg-2 col-lg-4 text-center text-lg-right pt-0 pt-lg-4">
                    <div class="onboarding-activities">
                        <img class="img-fluid onboarding-reflection-journal"
                            src="https://equityisdynamic-static.s3.amazonaws.com/onboard/reflection-journal.gif">
                        <img class="img-fluid onboarding-assessment"
                            src="https://equityisdynamic-static.s3.amazonaws.com/onboard/SelfAssessment.gif">
                    </div>
                </div>
                <div class="col-12 d-lg-none text-center text-md-right pt-5 mt-md-5">
                    <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                        (click)="moveToNextStep()">continue</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 6">
        <div class="container-fluid container-lg">
            <div class="row py-5">
                <div class="col-12 col-lg-6">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <div class="">
                            <div class="subtitle text-uppercase">FEATURES</div>
                            <h2 class="py-1">My Results</h2>
                            <div class="text-xlarge pt-5"><b>My Results</b> will show you a list of downloadable results
                                from your self-assessments, data explorations, and other work from your
                                <b>Activities</b> so that you can share with your colleagues.
                            </div>
                        </div>
                        <div class="d-none d-lg-block text-center text-lg-right pt-4">
                            <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                                (click)="moveToNextStep()">continue</button>
                        </div>
                    </div>
                </div>
                <div
                    class="offset-1 col-10 offset-md-2 col-md-8 offset-lg-0 col-lg-6 text-center text-lg-right pt-5 pt-lg-4">
                    <img class="img-fluid w-100"
                        src="https://equityisdynamic-static.s3.amazonaws.com/onboard/results.gif">
                </div>
                <div class="col-12 d-lg-none text-center text-md-right pt-5 mt-md-5">
                    <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                        (click)="moveToNextStep()">continue</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 7">
        <div class="container-fluid container-lg">
            <div class="row py-5">
                <div class="col-12 col-lg-6">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <div class="mb-lg-5">
                            <div class="subtitle text-uppercase">FEATURES</div>
                            <h2 class="py-1">My Community</h2>
                            <div class="text-xlarge pt-5">
                                <p>You aren’t on this Journey alone. The <b>My Community</b> section shows you all the
                                    ways
                                    you can connect with others who are also using Journey.</p>
                                <p>Connect through Slack, community events, or our <b>Participant Search</b> tool.</p>
                            </div>
                        </div>
                        <div class="d-none d-lg-block text-center text-lg-right pt-4 pt-lg-5 mt-lg-5">
                            <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                                (click)="moveToNextStep()">continue</button>
                        </div>
                    </div>
                </div>
                <div
                    class="offset-1 col-10 offset-md-2 col-md-8 offset-lg-1 col-lg-5 text-center text-lg-right pt-5 pt-lg-4 d-flex align-items-center">
                    <img class="img-fluid w-100"
                        src="https://equityisdynamic-static.s3.amazonaws.com/onboard/community.png">
                </div>
                <div class="col-12 d-lg-none text-center text-md-right pt-5 mt-md-5">
                    <button type="button" class="btn btn-primary px-4  text-blue" href="#"
                        (click)="moveToNextStep()">continue</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 8">
        <div class="container-fluid container-lg">
            <div class="row py-5">
                <div class="col-12 col-lg-6">
                    <div class="d-flex flex-column justify-content-between h-100">
                        <div class="mb-lg-5">
                            <div class="subtitle text-uppercase">FEATURES</div>
                            <h2 class="py-1">Participant Search</h2>
                            <div class="text-xlarge pt-5">
                                <p> The <b>Participant Search</b> lets you find other participants
                                    based on location or sector and reach out to them on email and Slack.
                                </p>
                                <p>You can choose whether or not your profile is visible to other participants in the
                                    Participant Search. Sharing can help you network and find community members in your
                                    area or sector.
                                </p>
                            </div>
                            <div class="pt-5">
                                <div>
                                    <label class="text-large" for="shareProfileOption"><input type="radio" checked
                                            name="shareProfileRadio" id="shareProfileOption" class="radio" value="yes"
                                            [(ngModel)]="searchConsent"> Yes, I’d
                                        like to
                                        share my
                                        profile</label>
                                </div>
                                <div>
                                    <label class="text-large" for="dontShareProfileOption"><input type="radio"
                                            name="shareProfileRadio" id="dontShareProfileOption" class="radio"
                                            value="no" [(ngModel)]="searchConsent"> No
                                        thanks,
                                        I’d like to hide my profile</label>
                                </div>
                            </div>
                        </div>
                        <div class="d-none d-lg-block text-center text-lg-right pt-4">
                            <button type="button" class="btn btn-active px-4" href="#"
                                (click)="onSubmitShareProfileForm()">finish</button>
                        </div>
                    </div>
                </div>
                <div
                    class="offset-1 col-10 offset-md-2 col-md-8 offset-lg-1 col-lg-5 text-center text-lg-right pt-5 pt-lg-4 d-flex align-items-center">
                    <img class="img-fluid w-100"
                        src="https://equityisdynamic-static.s3.amazonaws.com/onboard/Search.gif">
                </div>
                <div class="col-12 d-lg-none text-center text-md-right pt-5 mt-md-5">
                    <button type="button" class="btn btn-active px-4" href="#"
                        (click)="onSubmitShareProfileForm()">finish</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="currentIndex == 9">
        <div class="onboarding-final position-relative">
            <img class="img-fluid w-100" src="https://equityisdynamic-static.s3.amazonaws.com/onboard/background.png">
            <div class="onboarding-final-img-container">
                <img class="img-fluid ray" src="https://equityisdynamic-static.s3.amazonaws.com/onboard/Ray.gif">
                <img [ngClass]="{'img-fluid profile-pic' : true, 'd-none': !profileUserImage}"
                    src="{{profileUserImage}}">
            </div>
        </div>
        <div class="container-fluid py-5">
            <div class="row">
                <div
                    class="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3 text-center font-weight-normal h2">
                    Congratulations and welcome to
                    the community, {{user.firstName}}!</div>
            </div>
            <div class="row">
                <div class="col-12 text-center pt-5">
                    <button type="button" class="btn btn-active px-5" href="#" (click)="GoDashboard()">start my
                        journey</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="position-relative" *ngIf="currentIndex <= 8">
    <div class="full-progress-bar"></div>
    <div class="progress-bar" [ngStyle]="{'width': (currentIndex + 1) / 9 * 100 + '%'}"></div>
</div>